module.exports = __webpack_public_path__ + "img/trafego_e_mobilidade.37dde680.png";